import { IIcon } from '../interfaces'

export const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    viewBox='0 0 48 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    width={size || width}
    height={size || height}
    {...props}
  >
    <g clipPath='url(#clip0_5329_4617)'>
      <path
        d='M24 5.625C24.7771 5.625 25.4062 4.99585 25.4062 4.21875V1.40625C25.4062 0.629151 24.7771 0 24 0C23.2229 0 22.5938 0.629151 22.5938 1.40625V4.21875C22.5938 4.99585 23.2229 5.625 24 5.625Z'
        fill='#00FF00'
      />
      <path
        d='M30.6193 8.02551L33.4318 5.21301C33.9811 4.6637 33.9811 3.7738 33.4318 3.22449C32.8824 2.67517 31.9926 2.67517 31.4432 3.22449L28.6307 6.03699C28.0814 6.5863 28.0814 7.4762 28.6307 8.02551C29.1801 8.57483 30.0699 8.57483 30.6193 8.02551Z'
        fill='#00FF00'
      />
      <path
        d='M17.3807 8.02551C17.9301 8.57483 18.8199 8.57483 19.3693 8.02551C19.9186 7.4762 19.9186 6.5863 19.3693 6.03699L16.5568 3.22449C16.0074 2.67517 15.1176 2.67517 14.5682 3.22449C14.0189 3.7738 14.0189 4.6637 14.5682 5.21301L17.3807 8.02551Z'
        fill='#00FF00'
      />
      <path
        d='M12.6562 18.875C12.6562 15.7728 10.1334 13.25 7.03125 13.25C3.92908 13.25 1.40625 15.7728 1.40625 18.875C1.40625 21.9772 3.92908 24.5 7.03125 24.5C10.1334 24.5 12.6562 21.9772 12.6562 18.875Z'
        fill='#00FF00'
      />
      <path
        d='M24 11.3438C21.6738 11.3438 19.7812 13.2363 19.7812 15.5625C19.7812 20.9897 15.271 25.5 9.84375 25.5H7.03125C3.15454 25.5 0 28.6545 0 32.5313V46.5938C0 47.3709 0.62915 48 1.40625 48H12.6562C13.4323 48 14.0438 47.3709 14.0438 46.5952L14.0519 33.4446C22.2642 31.5095 28.2188 24.1154 28.2188 15.5625C28.2188 13.2363 26.3262 11.3438 24 11.3438Z'
        fill='url(#paint0_linear_5329_4617)'
      />
      <path
        d='M46.5938 18.875C46.5938 15.7728 44.0709 13.25 40.9688 13.25C37.8666 13.25 35.3438 15.7728 35.3438 18.875C35.3438 21.9772 37.8666 24.5 40.9688 24.5C44.0709 24.5 46.5938 21.9772 46.5938 18.875Z'
        fill='#00FF00'
      />
      <path
        d='M40.9686 25.4999H38.1561C34.9225 25.4999 31.9789 23.8179 30.1833 21.4023C29.3605 24.3057 27.9271 26.9406 26.0129 29.1968C28.2552 31.1761 31.026 32.7472 33.9476 33.443L33.9561 46.5951C33.9561 47.3707 34.5676 47.9999 35.3436 47.9999H46.5936C47.3707 47.9999 47.9999 47.3707 47.9999 46.5936V32.5311C47.9999 28.6544 44.8453 25.4999 40.9686 25.4999Z'
        fill='url(#paint1_linear_5329_4617)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_5329_4617'
        x1='14.1094'
        y1='11.3438'
        x2='14.1094'
        y2='48'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#00FF00' />
        <stop offset='1' stopColor='#3DD32F' stopOpacity='0' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_5329_4617'
        x1='37.0064'
        y1='21.4023'
        x2='37.0064'
        y2='47.9999'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#00FF00' />
        <stop offset='1' stopColor='#3DD32F' stopOpacity='0' />
      </linearGradient>
      <clipPath id='clip0_5329_4617'>
        <rect width='48' height='48' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
